import {
  ProjectAccessControlPolicyEntryResponse,
  removeProjectCredentials,
  setProjectCredentials,
} from '@xeovision/shared';

export const useProjectAuthZStore = defineStore('project-auth-z-store', () => {
  const projectHttpClient = useHttpClientStore().projects;

  const isProjectLocked = ref(true);
  const projectAccessControlPolicy = ref<ProjectAccessControlPolicyEntryResponse | null>(null);

  async function commitPassword(projectId: string, password: string): Promise<boolean> {
    if (projectAccessControlPolicy.value === null)
      throw new Error('Project access control policy is not set');

    try {
      const response = await projectHttpClient.authorizeAccessControlPolicy(
        projectAccessControlPolicy.value.id,
        {
          password,
        },
      );
      setProjectCredentials(projectId, response.data.token);
      return true;
    } catch (error) {
      removeProjectCredentials(projectId);
      return false;
    }
  }

  async function deleteProjectAccessControlPolicyPassword() {
    if (projectAccessControlPolicy.value === null) return;
    const response = await projectHttpClient.updateProjectAccessControlPolicyPassword(
      projectAccessControlPolicy.value.id,
      {
        password: null,
      },
    );
    projectAccessControlPolicy.value = response.data;
  }

  async function setProjectAccessControlPolicyPassword(password: string) {
    if (projectAccessControlPolicy.value === null) return;
    const response = await projectHttpClient.updateProjectAccessControlPolicyPassword(
      projectAccessControlPolicy.value.id,
      {
        password,
      },
    );
    projectAccessControlPolicy.value = response.data;
  }

  async function setProjectAccessControlPolicyAllowSourceModelDownload(
    allowSourceModelDownload: boolean,
  ) {
    if (projectAccessControlPolicy.value === null) return;
    const response = await projectHttpClient.updateProjectAccessControlPolicySettings(
      projectAccessControlPolicy.value.id,
      {
        allowSourceModelDownload,
      },
    );
    projectAccessControlPolicy.value = response.data;
  }

  return {
    isProjectLocked,
    projectAccessControlPolicy,
    commitPassword,
    deleteProjectAccessControlPolicyPassword,
    setProjectAccessControlPolicyPassword,
    setProjectAccessControlPolicyAllowSourceModelDownload,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useProjectAuthZStore, import.meta.hot));
}
